import { render, staticRenderFns } from "./table-4.vue?vue&type=template&id=a0b1c36c&scoped=true"
import script from "./table-4.vue?vue&type=script&lang=js"
export * from "./table-4.vue?vue&type=script&lang=js"
import style0 from "./table-4.vue?vue&type=style&index=0&id=a0b1c36c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b1c36c",
  null
  
)

export default component.exports